import React    from "react";
import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Microsoft logo using official brand colors
const MicrosoftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 21 21" fill="none">
    <rect x="1"  y="1"  width="9" height="9" fill="#f25022"/>
    <rect x="11" y="1"  width="9" height="9" fill="#7fba00"/>
    <rect x="1"  y="11" width="9" height="9" fill="#00a4ef"/>
    <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
  </svg>
);

// Microsoft SSO login button
// onClick - triggers Azure AD login redirect
const MicrosoftLoginButton = ({ onClick }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Button
      onClick={onClick}
      startIcon={<MicrosoftIcon />}
      sx={{
        background:    t.surface,
        border:        `1px solid ${t.border2}`,
        borderRadius:  "2px",
        padding:       "12px 28px",
        color:         t.text,
        fontSize:      "13px",
        fontWeight:    500,
        fontFamily:    "'DM Sans', sans-serif",
        textTransform: "none",
        letterSpacing: "0.01em",
        transition:    "all 0.2s",
        "&:hover": {
          background:  t.surface2,
          borderColor: t.border3,
          boxShadow:   `0 0 0 1px ${t.accent}22`,
        },
      }}
    >
      Sign in with Microsoft
    </Button>
  );
};

export default MicrosoftLoginButton;